import { isDefined } from '@sgme/fp';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import type { AppState } from 'state/state.model';
import { useFormatDateTime } from 'utils/date';

interface LastUpdateProps {
  tabId: string;
}

export function LastUpdate({ tabId }: LastUpdateProps) {
  const formatDateOrTime = useFormatDateTime();
  const lastUpdated = useSelector((state: AppState) => liveSelectors.getStreamingLastUpdate(state, tabId));
  return !isDefined(lastUpdated) ? null : (
    <span className="fs-6 me-2">
      <FormattedMessage
        id="secondaryMarket.sidePanel.label.lastUpdated"
        values={{ dateTime: formatDateOrTime(lastUpdated) }}
      />
    </span>
  );
}
